import React, { useContext, useEffect } from "react";
import { Container } from "react-bootstrap";
import { InfoContext } from "../providers/InfosContextProvider";
import Header from "../components/Header";
import Footer from "../components/Footer";

const logo = process.env.PUBLIC_URL + "/assets/images/transparente.png";

const About = () => {
  const { texts } = useContext(InfoContext);
  useEffect(() => {
    const pageTitle = texts?.aboutUs?.title || "Sobre Nós";
    document.title = `${pageTitle} | Casas do Nabão`;
  }, [texts]);
  return (
    <>
      <Header />
      <Container className="sell-property mb-5">
        <div
          className="about-container shadow-sm bg-white"
          style={{
            borderTop: "4px solid #a02020",
            borderRadius: "0.5rem",
            padding: "40px",
          }}
        >
          <div className="about-logo">
            <img src={logo} alt="Logo da Empresa" />
          </div>
          <div className="about-text">
            {texts.aboutUs.description.split("\n").map((para, index) => (
              <p
                key={index}
                className="lh-lg text-secondary"
                style={{ fontSize: "1.05rem", textAlign: "justify" }}
              >
                {para}
              </p>
            ))}
          </div>
        </div>
      </Container>
      <div className="div-footer">
        <Footer />
      </div>
    </>
  );
};

export default About;
